import { render, staticRenderFns } from "./ContactSmall.vue?vue&type=template&id=0c8b47de&scoped=true"
import script from "./ContactSmall.vue?vue&type=script&lang=js"
export * from "./ContactSmall.vue?vue&type=script&lang=js"
import style0 from "./ContactSmall.vue?vue&type=style&index=0&id=0c8b47de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b47de",
  null
  
)

export default component.exports